import React, { useEffect, useState } from "react";
import { useHistory, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
//UI
import { Form, Message } from "semantic-ui-react";
import Divider from "@material-ui/core/Divider";
import CircularProgress from "@material-ui/core/CircularProgress";
import HeadDetail from "../../../../components/headDetail";
import HeadDetailReservation from "../../../../components/headDetailReservation";
import "../../../styles/common.css";
import "semantic-ui-css/semantic.min.css";
//ACTIONS
import { createSpaceFlight } from "../../../../redux/actions/reservations/spaceFlight/createSpaceFlight";
import { updateSpaceFlight } from "../../../../redux/actions/reservations/spaceFlight/updateSpaceFlight";
import { initialStateSpaceFlight, } from "../../../../redux/actions/reservations/spaceFlight/fetchSpaceFlight";
import { fetchSpaceFlightFormCustom, initialStateSpaceFlightFormCustom } from "../../../../redux/slices/custom/reservations/cruise/spaceFlight/customSpaceFlightForm.slice";
//RESOURCE
import { scrollToTop, setSHourEndDateToNoon, setSHourStartDateToNoon } from "../../../resources/utils";
import { fetchFlightRoutes } from "../../../../redux/slices/custom/catalogs/flightRoutes/flightRoutes.slice";

export default function SpaceFlightForm() {
  let history = useHistory();
  let { cruise_id, reservation_id, booking_id, space_id, space_flight_id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { setValue, register, handleSubmit, errors } = useForm();
  const spaceFlightStateCustom = useSelector((state) => state.customSpaceFlightForm);
  const spaceFlightState = useSelector((state) => state.spaceFlightReducer);
  const { routes } = useSelector((state) => state.flightRoute);
  const [messageDate, setMessageDate] = useState(false);
  const [flightId, setFlightId] = useState('');
  const [flights, setFlights] = useState('');

  useEffect(() => {
    dispatch(fetchSpaceFlightFormCustom("", space_id, cruise_id, reservation_id, booking_id, space_flight_id))
    scrollToTop();
    return () => {
      dispatch(initialStateSpaceFlightFormCustom());
      dispatch(initialStateSpaceFlight());
    };
  }, [dispatch, cruise_id, space_flight_id, reservation_id, space_id, booking_id]);

  useEffect(() => {
    dispatch(fetchFlightRoutes(spaceFlightStateCustom.spaceFlight.flight_id));
  }, [spaceFlightStateCustom.spaceFlight.flight_id]);

  useEffect(() => {
    if (space_flight_id) {
      setValue("date", spaceFlightStateCustom.spaceFlight.date);
      setValue("flight_route_id", spaceFlightStateCustom.spaceFlight.flight_route_id);
      setValue("notes", spaceFlightStateCustom.spaceFlight.notes);
    }
  }, [setValue, spaceFlightStateCustom.spaceFlight, routes]);

  useEffect(() => {
    if (spaceFlightStateCustom.numberFlights.numberFlights > 0) {
      if (spaceFlightStateCustom.cruise.end_date_flight) {
        setValue("date", spaceFlightStateCustom.cruise.end_date_flight);
      }
    } else {
      if (spaceFlightStateCustom.cruise.start_date_flight) {
        setValue("date", spaceFlightStateCustom.cruise.start_date_flight);
      }
    }
  }, [spaceFlightStateCustom.numberFlights,]);

  useEffect(() => {
    const editingFlight = spaceFlightStateCustom.spaceFlight;
    if (space_flight_id) {
      setFlights(spaceFlightStateCustom.flights.filter(flight => flight.type === editingFlight.type));
    } else {
      const flightType = spaceFlightStateCustom.numberFlights.numberFlights > 0 ? 'return' : 'departure';
      setFlights(spaceFlightStateCustom.flights.filter(flight => flight.type === flightType));
    }
  }, [spaceFlightStateCustom.flights, spaceFlightStateCustom.numberFlights, spaceFlightStateCustom.spaceFlight]);

  if (spaceFlightStateCustom.fetching || spaceFlightState.fetching || !flights) {
    return <CircularProgress />;
  }

  const onSubmit = (data) => {
    if (space_flight_id) {
      data.space_id = space_id
      dispatch(updateSpaceFlight(space_flight_id, data));
    } else if (space_id) {
      dispatch(createSpaceFlight(space_id, data));
    }
  };

  if (spaceFlightState.message === "resource created successfully" || spaceFlightState.message === "resource updated successfully") {
    history.go(-1);
  }

  const handleChangeDate = (event) => {
    var selectedDate = new Date(event.target.value);
    var startDate = new Date(spaceFlightStateCustom.cruise.start_date_flight);
    var endDate = new Date(spaceFlightStateCustom.cruise.end_date_flight);
    startDate.setDate(startDate.getDate() + 1);
    endDate.setDate(endDate.getDate() - 1);
    if (selectedDate >= startDate && selectedDate <= endDate) {
      setMessageDate(true)
      event.target.value = spaceFlightStateCustom.cruise.start_date_flight;
    } else {
      setMessageDate(false)
    }
  }

  const handleChangeflight = (event) => {
    setFlightId(event.target.value)
    if (event.target.value) {
      dispatch(fetchFlightRoutes(event.target.value));
    }
  }


  return (
    <>
      {spaceFlightState.error ? (
        <Message negative content={t(spaceFlightState.error)} />
      ) : (
        ""
      )}

      <div className="ui breadcrumb">
        <Link to={`/cruises/${cruise_id}/cruise-detail`}>
          <div className="active section">{spaceFlightStateCustom.cruise.code}</div>
        </Link>
        <div className="divider">/</div>
        <div className="active section">
          <Link to={`/cruises/${cruise_id}/reservations`}>
            {t("reservation_title")}
          </Link>
        </div>
        <div className="divider">/</div>
        <div className="active section">
          <Link
            to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings`}
          >
            {t("cabin_title")}
          </Link>
        </div>
        <div className="divider">/</div>
        <div className="active section">
          {t("cabin_cabin")} {spaceFlightStateCustom.booking.cabin_name}
        </div>
        <div className="divider">/</div>
        <div className="active section">
          <Link
            to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings/${booking_id}/spaces`}
          >
            {t("space_title")}
          </Link>
        </div>
        <div className="divider">/</div>
        <div className="active section">
          <Link
            to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings/${booking_id}/spaces/${space_id}/spaceFlights`}
          >
            {t("space_flight_title")}
          </Link>
        </div>
        <div className="divider">/</div>
        <div className="active section">{t("space_flight_path")}</div>
      </div>
      <br />
      <br />
      <HeadDetail
        yacht_name={spaceFlightStateCustom.cruise.yacht_name}
        itinerary_name={spaceFlightStateCustom.cruise.itinerary_name}
        cruise_name={spaceFlightStateCustom.cruise.name}
        start_date={spaceFlightStateCustom.cruise.start_date_format}
        end_date={spaceFlightStateCustom.cruise.end_date_format}
      />
      <HeadDetailReservation
        reservation_date={spaceFlightStateCustom.reservation.creation_date}
        reservation_agency={spaceFlightStateCustom.reservation.agency_name}
        reservation_executive={spaceFlightStateCustom.reservation.user}
        reservation_type={spaceFlightStateCustom.reservation.cruise_type}
      />
      <br />

      <Form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <label>{t("general_information_tag")}</label>
          <Divider variant="fullWidth" />
          <br />
          <Form.Group widths="equal">
            <Form.Field>
              <label>{t("space_flight_date")}{" "}
                <span className="text_date_format">(dd-mm-yyyy)</span>
              </label>
              <input type="date" name="date" ref={register}
                onChange={handleChangeDate}
              />
              {messageDate && <span className="error_message">{t("spaceFlight_message_date")} </span>}
            </Form.Field>
            <Form.Field required>
              <label>{t("space_flight_path")}</label>
              <select aria-expanded="true" name="flight_id" value={flightId ? flightId : spaceFlightStateCustom.spaceFlight.flight_id} ref={register({ required: true })}
                onChange={handleChangeflight}
              >
                <option></option>
                {flights.map((flight) => (
                  <option className="selected item" key={flight.id} value={flight.id}>
                    {flight.code}
                  </option>
                ))}
              </select>
              {errors.flight_id && (<span className="error_message">{t("required_information")}{" "}</span>
              )}
            </Form.Field>
            <Form.Field required>
              <label>{t("route_name")}</label>
              <select aria-expanded="true" name="flight_route_id" ref={register({ required: true })}>
                <option></option>
                {routes.map((route) => (
                  <option className="selected item" key={route.id} value={route.id}>
                    {route.origin_city + ' - ' + route.destination_city}
                  </option>
                ))}
              </select>
              {errors.flight_route_id && (<span className="error_message">{t("required_information")}{" "}</span>)}
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <label>{t("space_flight_note")}</label>
              <textarea rows={3} placeholder={t("space_flight_note")} name="notes" ref={register}
              ></textarea>
              {errors.notes && (<span className="error_message">{t("required_information")}{" "}</span>)}
            </Form.Field>
          </Form.Group>
          <br />
          <Divider variant="middle" />
          <br />
          <Link
            to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings/${booking_id}/spaces/${space_id}/spaceFlights`}
          >
            <button type="button" className="ui button">
              {t("canceled_button")}
            </button>
          </Link>

          <button
            type="submit"
            className={
              spaceFlightStateCustom.processing
                ? "ui loading primary button"
                : "ui primary button"
            }
          >
            {t("save_button")}
          </button>
        </div>
      </Form>
    </>
  );
}
